import { format } from 'date-fns';
import { ReportColumn } from '../shared/types';
import { formatMoney } from '@/utils/currency';

export interface PaymentRow {
  payment_entry: string;
  date: string;
  supplier_name: string;
  purchase_invoice: string;
  payment_method: string;
  reference_number: string;
  amount_paid: number;
  user: string;
}

export const paymentColumns: ReportColumn<PaymentRow>[] = [
  { id: 'payment_entry', header: 'Payment Entry', accessorKey: 'payment_entry' },
  {
    id: 'date',
    header: 'Date',
    cell: (r) => (r.date ? format(new Date(r.date), 'd MMM yyyy') : ''),
    exportValue: (r) => r.date,
  },
  { id: 'supplier_name', header: 'Supplier', accessorKey: 'supplier_name' },
  { id: 'purchase_invoice', header: 'Purchase Invoice', accessorKey: 'purchase_invoice' },
  { id: 'payment_method', header: 'Payment Method', accessorKey: 'payment_method' },
  { id: 'reference_number', header: 'Reference Number', accessorKey: 'reference_number' },
  {
    id: 'amount_paid',
    header: 'Amount Paid',
    align: 'right',
    cell: (r) => `${formatMoney(r.amount_paid)}`,
    exportValue: (r) => r.amount_paid,
  },
];
